module.exports = __webpack_public_path__ + "assets/b5.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b5.png
// module id = 638
// module chunks = 0